import { SdmOffer, SdmSiteOffer } from "../models/site";
import axiosConfig from "./axiosConfig";

type SdmListResponse =
  | { result: { buy?: SdmOffer; sell?: SdmOffer } }
  | { results: SdmSiteOffer[] };

const getSiteSdmList = async (
  authToken: string,
  siteId: string,
  getAllResults?: boolean,
  onlyLinkedOrgs?: boolean,
  userOrgId?: string,
  isWired?: boolean
): Promise<SdmListResponse> => {
  const args: string[] = [];
  if (getAllResults) {
    args.push("getAllResults=true");
  }
  if (onlyLinkedOrgs) {
    args.push("onlyLinkedOrgs=true");
  }
  if (userOrgId) {
    args.push(`userOrgId=${userOrgId}`);
  }
  if (isWired) {
    args.push("isWired=true");
  }
  const { data } = await axiosConfig.get(
    `/site/${siteId}/marketplace${args.length ? `?${args.join("&")}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteSdmList;
